import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NavService } from '../../core/nav.service';
import { Lesson } from '../../lessons/shared/lesson';
import { ListObservable } from '../../shared/base/list-observable';
import { ObjectObservable } from '../../shared/base/object-observable';
import { Lecture } from '../shared/lecture';
import { LectureLessonService } from '../shared/lecture-lesson.service';

@Component({
  selector: 'app-lecture-lessons',
  templateUrl: './lecture-lessons.component.html'
})
export class LectureLessonsComponent implements OnInit {
  lessonsObservable: ListObservable<Lesson[]>;
  lectureObservable: ObjectObservable<Lecture>;

  constructor(private route: ActivatedRoute, private nav: NavService, private service: LectureLessonService) { }

  ngOnInit() {
    this.initNav();
    this.route.parent.data.subscribe((data: { lecture: ObjectObservable<Lecture> }) => this.lectureObservable = data.lecture);
    this.route.parent.params.subscribe(({ id }) => this.lessonsObservable = this.service.readList(id, 'name'));
  }

  private initNav() {
    this.nav.actions = [
      { text: '강좌로 돌아가기', commands: ['.'], route: this.route.parent.parent }
    ];
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-lessons/lecture-lessons.component.ts